import fetch from 'node-fetch';

const playlistName = 'TripTunes';

export const getSpotifyUserId = async (accessToken) => {
    const url = 'https://api.spotify.com/v1/me';
    const headers = {
        "Authorization": `Bearer ${accessToken}`
    };

    try {
        const response = await fetch(url, { headers });
        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        console.log('User ID:', data.id);
        return data.id;
    } catch (error) {
        console.error('Error fetching user ID:', error);
    }
}

export const createPlaylist = async (userId, accessToken) => {
  console.log('userID:', userId);
  const url = `https://api.spotify.com/v1/users/${userId}/playlists`;
  const headers = {
    "Authorization": `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const body = JSON.stringify({
    name: playlistName,
    description: "I hope you enjoy this playlist!",
    public: false
  });

  try {
    console.log('Creating playlist with URL:', url);
    console.log('Headers:', headers);
    console.log('Body:', body);

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: body
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error: ${response.statusText} - ${errorText}`);
    }

    const data = await response.json();
    console.log('Playlist created:', data);
    return data.id;
  } catch (error) {
    console.error('Error creating playlist:', error);
  }
};


export const getTrackId = async (trackName, artistName, accessToken) => {
  const query = `track:${trackName} artist:${artistName}`;
  const url = `https://api.spotify.com/v1/search?q=${encodeURIComponent(query)}&type=track&limit=1`;
  const headers = {
    "Authorization": `Bearer ${accessToken}`
  };

  try {
    const response = await fetch(url, { headers });
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    if (data.tracks.items.length > 0) {
      return data.tracks.items[0].uri;
    } else {
      throw new Error('Track not found');
    }
  } catch (error) {
    console.error('Error fetching track ID:', error);
  }
};

export const addTracksToPlaylist = async (accessToken, playlistId, trackUris) => {
  const url = `https://api.spotify.com/v1/playlists/${playlistId}/tracks`;
  const headers = {
    "Authorization": `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };

  const uris = await Promise.all(trackUris.map(async (track) => {
    const { trackName, artistName } = track;
    return await getTrackId(trackName, artistName, accessToken);
  }));

  const body = JSON.stringify({
    uris: uris
  });

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: body
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Tracks added to playlist:', data);
  } catch (error) {
    console.error('Error adding tracks to playlist:', error);
  }
};

export const getAccessToken = (clientId, redirectUri) => {
  return new Promise((resolve) => {
    const scope = 'playlist-modify-private playlist-modify-public';
    const generateRandomString = (length) => {
      let text = '';
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    };

    const stateKey = 'spotify_auth_state';
    const state = generateRandomString(16);
    localStorage.setItem(stateKey, state);

    let url = 'https://accounts.spotify.com/authorize';
    url += '?response_type=token';
    url += '&client_id=' + encodeURIComponent(clientId);
    url += '&scope=' + encodeURIComponent(scope);
    url += '&redirect_uri=' + encodeURIComponent(redirectUri);
    url += '&state=' + encodeURIComponent(state);

    window.location.href = url;
    resolve();
  });
};

  
  export const getAccessTokenFromUrl = () => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    return params.get('access_token');
  };